import React from 'react';
import { convertToSlug, getIconSrcFromSrcList } from 'globals/utils';
import iconDefaultFallbackSrc from 'assets/icons/categories/default-fallback.svg';
import * as IconSources from 'assets/icons/categories';

const iconSrcList = Object.values(IconSources);

interface FsCategoryIconLoaderProps {
  categoryName: string;
  size?: number;
}

const FsCategoryIconLoader: React.FC<FsCategoryIconLoaderProps> = ({
  categoryName,
  size,
}) => {
  const iconSrc = categoryName
    ? getIconSrcFromSrcList(
        iconSrcList,
        convertToSlug(categoryName),
        iconDefaultFallbackSrc
      )
    : iconDefaultFallbackSrc;
  return (
    <img
      src={iconSrc}
      style={{ width: size || 30 }}
      alt={categoryName}
      data-test="category-icon-loader"
    />
  );
};

FsCategoryIconLoader.displayName = 'FsCategoryIconLoader';

export default FsCategoryIconLoader;
